var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('PLPProductBox',{attrs:{"product":_vm.item,"classes":_vm.classes,"pricesData":_vm.pricesData,"pricetag":_vm.pricetag}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }